import React, { useState, useEffect } from "react";
import firebase from "@firebase/app";
import "@firebase/auth";
import OperationsTable from "../components/Operations/OperationsTable";
import {
    deleteImeis,
    getUser,
    blockUser,
    unblockUser,
    EnableRetailerRelocationButton,
    VerifyRetailer
    } from "../services/UserService";
import "react-datepicker/dist/react-datepicker.css";
import {Card, Container,Col,Row,Button,Table} from "react-bootstrap";
import { Input } from "reactstrap";
import {ConfirmBlockModal} from "../components/Modals/ConfirmBlockModal";
import {ConfirmRelocationModal} from "../components/Modals/ConfirmRelocationModal";
import {ConfirmVerifyRetailerModal} from "../components/Modals/ConfirmVerifyRetailerModal";
import {ConfirmDeleteImeisModal} from "../components/Modals/ConfirmDeleteImeisModal";
import {toDateTimeFormat} from "../services/Utils";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "../assets/css/table.css"
import constants from "../constants";

function UserListView() {
  const [user, setUser] = useState(null);
  const [imeiToDelete, setImeiToDelete] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfirmBlockModal, setShowConfirmBlockModal] = useState(false);
  const [showConfirmRelocationModal, setShowConfirmRelocationModal] = useState(false);
  const [showConfirmRetailerVerificationModal, setShowConfirmRetailerVerificationModal] = useState(false);
  const [showConfirmDeleteImiesModal, setShowConfirmDeleteImiesModal] = useState(false);

  const [userLoading, setUserLoading] = useState(false);
  const [uid, setUid] = useState('');

  const handleShowConfirmBlockModal = () => {
    setShowConfirmBlockModal(true)
  };
  const handleShowConfirmRelocationModal = () => {
    setShowConfirmRelocationModal(true)
  };
  
  const handleShowRetailerVerificationModal = () => {
    setShowConfirmRetailerVerificationModal(true)
  };

  const handleshowConfirmDeleteImiesModal = (imei) => {
    if (imei && imei.id)
      setImeiToDelete(imei)
    else
      setImeiToDelete(null)
    setShowConfirmDeleteImiesModal(true)
  };

  function onChange(user) {
    if (!user) {
      window.location.href = "/";
    }
    setLoading(false);
  }

  React.useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(onChange);
    return () => unsubscribe();
  }, []);

  const validatePhoneNumber = phoneNumber => {
    return constants.MOROCCO_PHONE_REGEX.test(phoneNumber);
  };

  const formatPhoneNumber = (number) => {
    if (!number) return number;
    if (number.startsWith("0")) {
      return "+212" + number.substr(1);
    }
    return number;
  };

  useEffect(async () => {
    if (!loading) {
      console.log(window.location)
      let url = new URL(window.location);
      let urlsp = url.searchParams;
      let phoneNumber = urlsp.get("uid")
      if (phoneNumber) {
        if (phoneNumber.startsWith(' '))
          phoneNumber = '+' + phoneNumber.trim()
        loadUser(phoneNumber)
      }
    }
  }, [loading]);

  const loadUser = async (phoneNumber) => {
    if (!validatePhoneNumber(phoneNumber)) {
      alert("invalid phone number")
      return; 
    }
    phoneNumber = formatPhoneNumber(phoneNumber)
    if (!loading) {
      setUserLoading(true);
      const user = await getUser(phoneNumber);
      setUser(user);
      setUserLoading(false);
    }
  }

  const handleCloseConfirmBlockModal = () => setShowConfirmBlockModal(false);
  const handleCloseConfirmRelocationModal = () => setShowConfirmRelocationModal(false);
  const handleCloseConfirmRetailerVerificationModal = () => setShowConfirmRetailerVerificationModal(false);

  const handleCloseConfirmDeleteImeisModal = () => setShowConfirmDeleteImiesModal(false);

  const handleBlockConfirmClick = async (user, blockHours, blockImei, note, reason) => {
    setShowConfirmBlockModal(false);
    let status = false;
    if (user.status == 'BLOCKED')
      status = await unblockUser(user.phoneNumber);
    else
      status = await blockUser(user.phoneNumber, blockHours, blockImei, note, reason);
    if (status)
      loadUser(user.phoneNumber)
  }

  const handleRetailerVerificationConfirmClick = async (user) => {
    setShowConfirmRetailerVerificationModal(false);
    let status = await VerifyRetailer(user.phoneNumber);
    if (status) {
      alert(user.phoneNumber + ' is confirmed')
      await loadUser(user.phoneNumber)
    }
  }

  const handleRelocationConfirmClick = async (user) => {
    setShowConfirmRelocationModal(false);
    let status = await EnableRetailerRelocationButton(user.phoneNumber);
    if (status)
      alert("relocation button is enabled for retailer" + user.phoneNumber)
  }

  const handleDeleteImeis = async (user, imei) => {
    setShowConfirmDeleteImiesModal(false);
    let status = false;
      status = await deleteImeis(user.phoneNumber, imei?.id);
    if (status)
      loadUser(user.phoneNumber)
  }

  const actionButton = (user) => {
    if (user.status == "ACTIVE")
      return <Button Button style={{float:'right' , marginLeft : 8}} onClick={handleShowConfirmBlockModal} variant="danger" >block</Button>
    if (user.status == "BLOCKED")
      return <Button Button style={{float:'right' , marginLeft : 8}} onClick={handleShowConfirmBlockModal} variant="success" >unblock</Button>
  }

  const renderRetailerButtons = (user) => {
    if (user.status == 'ACTIVE' && user.accountType == 'RETAILER') {
      let relocationButton = <Button style={{margin:"0px 20px"}} onClick={handleShowConfirmRelocationModal} variant="primary" >Enable Relocation</Button>
      let verifyButton = <Button onClick={handleShowRetailerVerificationModal} variant="success" >Verify</Button>
      let array = [relocationButton];
      if (!user.verified)
        array = [relocationButton,verifyButton]
      return array.map((x,idx) => <span index={idx}>{x}</span>);
    }
    return <></>
  }

  const renderImeis = (imeis) => 
  {
    if (!imeis || imeis.length == 0)
      return <></>
    return (
    <Row>
      <Col md="12">
        <Card className="card-plain table-plain-bg">
          <Card.Body className="table-full-width table-responsive px-0">
            <Table id="invoice">
              <thead>
                <tr>
                  <th className="border-0">imei</th>
                  <th className="border-0">Used At</th>
                  <th className="border-0">Shared With</th>
                  <th className="border-0">Action</th>
                </tr>
              </thead>
              <tbody>
                {
                  imeis.map((imei, index) => 
                  {
                    return (
                      <tr key={index}>
                        <td>{imei.imei}</td>
                        <td>{imei.usedAt}</td>
                        <td>{imei.sharedWith}</td>
                        <td>
                          <Button onClick={() => handleshowConfirmDeleteImiesModal(imei)} variant="danger" >Delete</Button>
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </Table>
            <Button onClick={handleshowConfirmDeleteImiesModal} variant="danger" >Delete all Imeis</Button>
          </Card.Body>
        </Card>
      </Col>
    </Row>
    );
  }
  const renderUserInfo = (user) => 
  {
    if (loading || userLoading) {
      return (
        <div style={{ flex: 1, textAlign: "center" }}>
          <Loader type="TailSpin" color="#00BFFF" height={100} width={100} />
        </div>
      );
    }
    if (!user)
      return <></>
    return <>
      <Row>
      <Col md="12">
        <Card className="card-plain table-plain-bg">
          <Card.Body className="table-full-width table-responsive px-0">
            <Table id="invoice">
              <thead>
                <tr>
                  <th className="border-0">Phone number</th>
                  <th className="border-0">AccountType</th>
                  <th className="border-0">Status</th>
                  <th className="border-0">Block Count</th>
                  <th className="border-0">Action</th>
                </tr>
              </thead>
              <tbody>
                  <tr>
                    <td>{user.phoneNumber}</td>
                    <td>{user.accountType}</td>
                    <td>{user.status}</td>
                    <td>{user.history.length}</td>
                    <td>
                      {actionButton(user)}
                      {renderRetailerButtons(user)}
                    </td>
                  </tr>
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
    </Row>
    {renderImeis(user.imeis)}
    {renderBlockHistory(user)}
    <OperationsTable operations={user.operations} />
    </>
  }

  const renderBlockHistory = (user) => {

    if (user.history.length > 0)
      return (
        <>
          Block History
          <Table id="invoice">
            <thead>
              <tr>
                <th className="border-0">Block Date</th>
                <th className="border-0">Unblock Date</th>
                <th className="border-0">Blocked Imei</th>
                <th className="border-0">Note</th>
              </tr>
            </thead>
            <tbody>
              {user.history.map((block, index) => {
                  return (
                    <tr key={index}>
                      <td>{toDateTimeFormat(block.blockDate)}</td>
                      <td>{toDateTimeFormat(block.unblockDate)}</td>
                      <td>{block.blockedImei}</td>
                      <td>{block.note}</td>
                    </tr>
                  );
              })}
            </tbody>
          </Table>
          <hr></hr>
        </>
      );
  }

  return (
    <Container fluid>
      <ConfirmBlockModal
        show={showConfirmBlockModal}
        handleClose={handleCloseConfirmBlockModal}
        handleClick={handleBlockConfirmClick}
        user={user}
      />
      <ConfirmRelocationModal
        show={showConfirmRelocationModal}
        handleClose={handleCloseConfirmRelocationModal}
        handleClick={handleRelocationConfirmClick}
        user={user}
      />
      <ConfirmVerifyRetailerModal
        show={showConfirmRetailerVerificationModal}
        handleClose={handleCloseConfirmRetailerVerificationModal}
        handleClick={handleRetailerVerificationConfirmClick}
        user={user}
      />
      <ConfirmDeleteImeisModal
        show={showConfirmDeleteImiesModal}
        handleClose={handleCloseConfirmDeleteImeisModal}
        handleClick={handleDeleteImeis}
        user={user}
        imei={imeiToDelete}
      />
      <Row>
        <Col md="12">
          <Card className="card-plain table-plain-bg">
            <Card.Header>
              <Row style={{ alignItems: "flex-end" }}>
                <Col md="4">
                  <label htmlFor="name">Phone number</label>
                  <Input value={uid} onChange={(e) => {
                    setUid(e.target.value);
                  }}/>
                </Col>
                <Col md="3">
                  <Button onClick={() => {
                    loadUser(uid);
                  }} variant="success" >Search</Button>
                </Col>
              </Row>
            </Card.Header>
          </Card>
        </Col>
      </Row>
      {renderUserInfo(user)}
    </Container>
  );
}

export default UserListView;
